import React, { memo } from 'react';
import { useRouter } from 'next/router';
import AssociatedContentItem from './AssociatedContentItem';
import AssociatedContentSection from './AssociatedContentSection';
import MissingContent from '../../../../ui-components/MissingContent/MissingContent';
import { SectionContainer } from './AssociatedContent.styles';
import { listTrackingEvent } from 'app/utils/statistics/customEvents';
import { trackCustomEvent } from 'app/utils/statistics/clientStatistics';

export const isSectionDefaultExpanded = (routerQuery, section, selectedVideoId) => {
    return (
        routerQuery.tab === section.id ||
        section.items.some(({ item }) => item.videoSvtId === selectedVideoId) ||
        section.selectionType === 'upcoming'
    );
};

const AssociatedContentInner = ({ sections, selectedVideoId, progress, router }) => {
    return (
        <SectionContainer>
            {sections && sections.length ? (
                sections.map((section, i) => {
                    const isUpcoming = section.id === 'upcoming';
                    const defaultExpanded = isSectionDefaultExpanded(router.query, section, selectedVideoId);
                    const maxItems = isUpcoming ? 1 : 10;

                    return (
                        <AssociatedContentSection
                            key={section.id}
                            name={section.name}
                            defaultExpanded={defaultExpanded}
                            id={section.id}
                            max={maxItems}
                        >
                            {section.items.map((content, i) => (
                                <AssociatedContentItem
                                    key={`associated-${i}`}
                                    content={content}
                                    type={section.id}
                                    selectedVideoId={selectedVideoId}
                                    progress={progress}
                                    trackClick={(e, leadsToPlayable) => {
                                        //{ listID, listType, listItemIndex, listExpandedState, contentId },

                                        const { listId, listType } = section.analyticsIdentifiers;
                                        trackCustomEvent(
                                            listTrackingEvent(
                                                {
                                                    listID: listId,
                                                    listType,
                                                    listItemIndex: i + 1,
                                                    contentId: content.item.svtId,
                                                    leadsToPlayable,
                                                },
                                                e.target
                                            )
                                        );
                                    }}
                                />
                            ))}
                        </AssociatedContentSection>
                    );
                })
            ) : (
                <MissingContent />
            )}
        </SectionContainer>
    );
};
const areEqual = (prevProps, nextProps) => nextProps.router.query.modalId;

const AssociatedContent = memo(AssociatedContentInner, areEqual);

const AssociatedContentContainer = ({ sections, selectedVideoId, progress }) => {
    const router = useRouter();

    return (
        <AssociatedContent
            sections={sections}
            selectedVideoId={selectedVideoId}
            progress={progress}
            router={router}
        />
    );
};

export default AssociatedContentContainer;
